<template>
  <div id="page" ref="homePage" class="page">
    <img class="banner" src="@/modules/interview/images/banner2.png">
    <process :process-val="2" />
    <div class="main">
      <div class="content-box">
        <div class="tips" />
        <div v-for="(item, index) in list" :key="item.attr_id" class="form-item">
          <div
            v-if="item.is_type === 0"
            v-show="item.is_relate == 0 || (item.is_relate == 1 && dataModelShow[item.relate_id] == item.value_id)"
            class="block-box"
          >
            <div class="title">{{ item.sort }}.{{ item.name }}<span v-if="item.required == 1" class="reb">*</span></div>
            <div v-if="item.intro" class="hint">{{ item.intro }}</div>
            <van-field v-model="dataModel[index].value" placeholder="请确保与报名名字一致" class="step-box" />
          </div>
          <div
            v-if="item.is_type === 1"
            v-show="item.is_relate == 0 || (item.is_relate == 1 && dataModelShow[item.relate_id] == item.value_id)"
            class="block-box"
          >
            <div class="title">{{ item.sort }}.{{ item.name }}<span v-if="item.required == 1" class="reb">*</span></div>
            <div v-if="item.intro" class="hint">{{ item.intro }}</div>
            <van-field v-model="dataModel[index].value" type="textarea" autosize class="step-box textarea" />
          </div>
          <div
            v-if="item.is_type === 2"
            v-show="item.is_relate == 0 || (item.is_relate == 1 && dataModelShow[item.relate_id] == item.value_id)"
            class="block-box"
          >
            <div class="title">{{ item.sort }}.{{ item.name }}<span v-if="item.required == 1" class="reb">*</span><span class="gary">(单选)</span></div>
            <div v-if="item.intro" class="hint">{{ item.intro }}</div>
            <van-radio-group v-model="dataModel[index].value" @change="radioChange(dataModel[index])">
              <van-radio v-for="(oItem) in item.value" :key="oItem" :name="oItem" class="step-box">
                <template #icon="props">
                  <div :class="['select-box', props.checked ? 'step-sel' : '']"> {{ oItem | radioFilter }}</div>
                </template>
              </van-radio>
              <van-radio v-if="item.other == 1" name="more" label-disabled class="step-box">
                <template #icon="props">
                  <div :class="['select-box', props.checked ? 'step-sel' : '']"> 其他<input v-model="dataModel[index].otherContent" class="more-input"></div>
                </template>
              </van-radio>
            </van-radio-group>
          </div>
          <div
            v-if="item.is_type === 3"
            v-show="item.is_relate == 0 || (item.is_relate == 1 && dataModelShow[item.relate_id] == item.value_id)"
            class="flex-box"
          >
            <div class="title">{{ item.sort }}.{{ item.name }}<span v-if="item.required == 1" class="reb">*</span><span class="gary">(多选)</span></div>
            <div v-if="item.intro" class="hint">{{ item.intro }}</div>
            <img v-if="item.attr_id == '4165'" src="../images/person.png">
            <van-checkbox-group v-model="dataModel[index].value">
              <van-checkbox v-for="cItem in item.value" :key="cItem.value_id" :name="cItem" class="step-box">
                <template #icon="props">
                  <div :class="['select-box', props.checked ? 'step-sel' : '']">{{ cItem | radioFilter }}</div>
                </template>
              </van-checkbox>
              <van-checkbox v-if="item.other == 1" name="more" label-disabled class="step-box">
                <template #icon="props">
                  <div :class="['select-box', props.checked ? 'step-sel' : '']"> 其他<input v-model="dataModel[index].otherContent" class="more-input"></div>
                </template>
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
        <van-button v-if="!isClickForm" class="submit-btn" size="large" @click="finishForm">完成</van-button>
        <van-button v-else loading class="submit-btn" size="large" loading-text="提交中..." />
      </div>
      <div class="bottom-logo">
        <img class="logo-path" src="@/modules/interview/images/logo.png">
      </div>
    </div>
  </div>
</template>

<script>
import { Button, RadioGroup, Radio, Field, Checkbox, CheckboxGroup, Toast, Dialog } from 'vant'
import process from '../components/process'
import { getActivityEnroll, enrollAdd, userAttributes } from '@/api/apply'
import { getLogin } from '@/utils/auth' // 获取auth参数

export default {
  name: 'Evaluation',
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    process
  },
  filters: {
    regionFilter(val) {
      if (val === '请选择') {
        return val
      } else {
        var value = val.province.name + ' ' + val.city.name + ' ' + val.district.name
        return value
      }
    },
    radioFilter(val) {
      var data = JSON.parse(val)
      return data.content
    }
  },
  data: function() {
    return {
      activityId: 484,
      isClickForm: false, // 是否提交过表单 防多次点击
      dataModel: [],
      dataModelShow: [], // 关联显示
      list: []
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      getActivityEnroll({ 'activity_id': this.activityId, 'open_id': getLogin() }).then(resolve => {
        if (resolve.data.code === 200) {
          this.getRecord(resolve.data.data)
        } else {
          Toast(resolve.data.data)
        }
      })
    },
    // 获取用户填充数据
    getRecord(data) {
      userAttributes({ 'activity_id': this.activityId, 'open_id': getLogin() }).then(resolve => {
        if (resolve.data.code === 200) {
          var record = resolve.data.data
          var recordData = {}
          var i = 0
          for (; i < record.length; i++) {
            if (!recordData[record[i].attribute_id]) {
              if (record[i].is_type === 2 && record[i].value) {
                recordData[record[i].attribute_id] = JSON.stringify({ value_id: parseInt(record[i].value.value_id), content: record[i].value.content })
              } else if (record[i].is_type === 3 && record[i].value) {
                recordData[record[i].attribute_id] = record[i].value.map(item => {
                  item = {
                    value_id: parseInt(item.value_id),
                    content: item.content
                  }
                  return JSON.stringify(item)
                })
              } else {
                recordData[record[i].attribute_id] = record[i].value
              }
            }
          }
          console.log('填充数据', recordData)
          if (i === record.length) {
            this.dataFormat(data, recordData)
          }
        } else {
          Toast(resolve.data.data)
        }
      })
    },
    // 数据格式化
    dataFormat(data, recordData) {
      this.list = data.attribute.map(item => {
        if (item.is_type === 2 || item.is_type === 3) {
          item.value = item.value.map(i => {
            return JSON.stringify(i)
          })
        }
        return item
      })
      console.log(this.list)
      this.dataModel = data.attribute.map((item) => {
        switch (item.is_type) {
          case 2: // 单选
            item = {
              value: recordData[item.attribute_id] ? recordData[item.attribute_id] : '',
              attr_id: item.attr_id,
              required: item.required,
              type: item.is_type,
              intro: item.intro,
              other: item.other, // 最后一项是否为其他
              is_relate: item.is_relate, // 是否开启关联
              relate_id: item.relate_id, // 关联id
              value_id: item.value_id, // 关联选项id
              attribute_id: item.attribute_id, // 字段ID
              otherContent: item.otherContent // 最后一项是否为其他(内容)
            }
            this.dataModelShow[item.attr_id] = item.value ? JSON.parse(item.value).value_id : -1
            break
          case 3: // 多选
            item = {
              value: recordData[item.attribute_id] ? recordData[item.attribute_id] : [],
              attr_id: item.attr_id,
              required: item.required,
              type: item.is_type,
              intro: item.intro,
              other: item.other, // 最后一项是否为其他
              is_relate: item.is_relate, // 是否开启关联
              relate_id: item.relate_id, // 关联id
              value_id: item.value_id, // 关联选项id
              attribute_id: item.attribute_id, // 字段ID
              otherContent: item.otherContent // 最后一项是否为其他(内容)
            }
            break
          case 9: // 图片
          case 10: // 音频
          case 11: // 视频
          case 12: // 文件
            item = {
              value: [],
              attr_id: item.attr_id,
              required: item.required,
              type: item.is_type,
              intro: item.intro,
              is_relate: item.is_relate, // 是否开启关联
              relate_id: item.relate_id, // 关联id
              value_id: item.value_id, // 关联选项id
              attribute_id: item.attribute_id // 字段ID
            }
            break
          default:
            item = {
              value: recordData[item.attribute_id] ? recordData[item.attribute_id] : '',
              attr_id: item.attr_id,
              required: item.required,
              type: item.is_type,
              intro: item.intro,
              is_relate: item.is_relate, // 是否开启关联
              relate_id: item.relate_id, // 关联id
              value_id: item.value_id, // 关联选项id
              attribute_id: item.attribute_id // 字段ID
            }
        }
        return item
      })
      console.log(this.dataModel)
    },
    // 指定选项设置  ------------------------------------------------------------------------------- 比较好找
    radioChange(e) {
      if (this.dataModelShow[e.attr_id]) {
        var val = this.dataModelShow[e.attr_id]
        var list = this.dataModel
        // 清空掉已经选择的数据,根据ID
        for (var i = 0; i < list.length; i++) {
          if (list[i].value_id === val) {
            switch (list[i].type) {
              case 3: // 多选
              case 9: // 图片
              case 10: // 音频
              case 11: // 视频
              case 12: // 文件
                list[i].value = []
                list[i].otherContent = ''
                break
              default:
                list[i].value = ''
                list[i].otherContent = ''
            }
          }
        }
        this.dataModel = list
        var data = e.value !== 'more' && e.value ? JSON.parse(e.value) : 'more'
        this.$set(this.dataModelShow, e.attr_id, data.value_id)
      }
    },
    // 完成表单
    finishForm: function() {
      var isRequired = 0
      var dataModel = JSON.parse(JSON.stringify(this.dataModel))
      // 遍历查看是否有空项
      console.log(dataModel)
      for (let i = 0; i < dataModel.length; i++) {
        const item = dataModel[i]
        if (item.required === 1 && (item.value === '' || item.value.length === 0) && (this.dataModelShow[item.relate_id] === item.value_id || item.relate_id === 0)) {
          Toast('请检查必填项')
          break
        }
        if (item.type === 2 && item.other === 1 && item.value === 'more') {
          console.log('单选其他')
          if (item.otherContent) {
            item.value = {
              value_id: 0,
              content: item.otherContent
            }
          } else {
            Toast('请输入【其他】')
            break
          }
        }
        if (item.type === 3 && item.other === 1 && item.value.indexOf('more') !== -1) {
          if (item.otherContent) {
            item.value.splice(item.value.indexOf('more'), 1)
            item.value[item.value.length] = {
              value_id: 0,
              content: item.otherContent
            }
          } else {
            Toast('请输入【其他】')
            break
          }
        }
        // 手机号码，邮箱正则
        if (item.attribute_id === 12 && !/^1\d{10}$/.test(item.value)) {
          Toast('手机格式有误')
          break
        }
        if (item.attribute_id === 13 && !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(item.value)) {
          Toast('邮箱格式有误')
          break
        }
        isRequired++
      }
      if (isRequired === dataModel.length) { // 暂时注释掉非空检查
        const sweeterArray = dataModel.map(item => {
          var val
          if (item.type === 9 || item.type === 10 || item.type === 11 || item.type === 12) {
            val = {
              attr_id: item.attr_id,
              values: item.value.length > 0 ? item.value[0].file : '',
              type: item.type
            }
          } else if (item.type === 2) {
            var isObject = item.value.toString() === '[object Object]'
            const arr = item.value && !isObject ? JSON.parse(item.value) : item.value
            val = {
              attr_id: item.attr_id,
              values: arr,
              type: item.type
            }
          } else if (item.type === 3) {
            val = {
              attr_id: item.attr_id,
              values: item.value.length > 0 ? item.value.map(i => {
                var isObject = i.toString() === '[object Object]'
                i = i && !isObject ? JSON.parse(i) : i
                return i
              }) : [],
              type: item.type
            }
          } else {
            val = {
              attr_id: item.attr_id,
              values: item.value,
              type: item.type
            }
          }
          return val
        })
        // 防止多次点击
        if (!this.isClickForm) {
          this.isClickForm = true
          console.log('sweeterArray', sweeterArray)
          this.submitPort(sweeterArray)
        } else {
          Toast('正在提交..')
        }
      }
    },
    submitPort(sweeterArray) {
      var that = this
      enrollAdd({
        'activity_id': this.activityId,
        'open_id': getLogin(),
        'enrollValue': sweeterArray
      }).then(res => {
        this.isClickForm = false
        if (res.data.code === 200 || res.data.code === 2205) {
          Dialog.alert({
            title: '温馨提示',
            message: '测评提交成功，快去预约面试吧～'
          }).then(() => {
            that.$router.replace('/') // 返回首页
          })
        } else {
          Toast(res.data.data)
        }
      })
    }
  }
}
</script>

<style lang="less">
  .page{
    position: relative;
    width: 375px;
    padding-top: 20px;
    padding-bottom: 20px;
    .banner{
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
    .main {
      position: relative;
      z-index: 1;
      width: 300px;
      margin: 80px auto 0 auto;
      .tips{
        position: absolute;
        top: -20px;
        left: 20px;
        width: 140px;
        height: 35px;
        background: url("../images/evaluation_tips.png") no-repeat;
        background-size: contain;
      }
      .content-box {
        border-radius: 10px 10px 0 10px;
        background: #fff;
        padding: 10px 20px 20px 20px;
      }
      .form-item {
        .title{
          color: #000;
          font-size: 15px;
          line-height: 25px;
          font-weight: 600;
          margin-top: 16px;
          .reb{
            color: red;
            padding: 0 4px;
            font-weight: 400;
          }
          .gary{
            padding: 0 4px;
            color: #999999;
            font-weight: 400;
          }
        }
        .hint{
          font-size: 14px;
          line-height: 25px;
          padding: 8px 0;
          word-break: break-all;
          white-space: pre-line;
          color: #999;
        }
        .step-box{
          font-size: 13px;
          display: block;
          border-radius: 4px;
          margin: 8px 0;
          padding: 4px 8px;
          color: #666;
          background: #EDEDED;
          &.textarea{
            line-height: 26px;
          }
        }
        .van-radio, .van-checkbox{
          background: none;
          padding: 0;
          .van-radio__icon{
            height: auto;
          }
          .van-checkbox__icon{
            height: auto;
          }
        }
        .select-box{
          font-size: 13px;
          margin: 0;
          background: #EDEDED;
          padding: 8px;
          &.step-sel{
            background: #f6e1da;
            color: #EE5030;
          }
        }
        .more-input{
          margin-left: 10px;
          height: 25px;
          background: none;
        }
      }
      .submit-btn{
        width: 100%;
        border: 1px solid #333;
        text-align: center;
        height: 38px;
        line-height: 38px;
        border-radius: 4px;
        font-weight: bold;
        color: #333;
        font-size: 18px;
        margin: 20px auto 40px auto;
      }
      .bottom-logo{
        border-radius: 0 0 10px 0;
        background: #fff;
        width: 60%;
        height: 20px;
        margin-left: 40%;
        padding-bottom: 10px;
        position: relative;
        &:before{
          content: '';
          font-size:0;
          border-style:solid;
          overflow:hidden;
          position:absolute;
          border-width:45px;
          border-color: transparent #fff transparent transparent;
          left:-90px;
          bottom:0;
          z-index: -1;
        }
        .logo-path{
          position: absolute;
          top: -5px;
          width: 85%;
          margin-left: 10px;
        }
      }
    }
  }
</style>
